import React, { useState } from 'react';
import style from './mobileHeader.module.scss';
import Logo from 'icons/logo';
import { Link } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import cx from 'classnames';
import BurgerIcon from 'icons/burger';
import CloseIcon from 'icons/close';
import Drawer from '@mui/material/Drawer';
import MobileMenu from 'components/mobileMenu/mobileMenu';

export default function MobileHeader({
  pageIsLoading,
}: {
  pageIsLoading: boolean;
}) {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => setMobileMenuOpen(!isMobileMenuOpen);

  return (
    <>
      <div className={cx(style.container, 'adaptive-header__container')}>
        <div className={style.left}>
          <Link
            onClick={() => setMobileMenuOpen(false)}
            className={'adaptive-header__logo'}
            to="/"
          >
            <Logo className={style.logo}></Logo>
          </Link>
        </div>
        <div className={cx(style.right, 'noselect')}>
          {pageIsLoading ? (
            <Skeleton variant="rectangular" width={30} height={17} />
          ) : isMobileMenuOpen ? (
            <CloseIcon
              className={style.close}
              strokeColor="#6A4192"
              onClick={toggleMobileMenu}
            ></CloseIcon>
          ) : (
            <BurgerIcon onClick={toggleMobileMenu}></BurgerIcon>
          )}
        </div>
      </div>
      <Drawer
        variant="permanent"
        sx={{
          display: isMobileMenuOpen ? 'flex' : 'none',
        }}
        classes={{
          paper: cx(style.drawer),
        }}
        anchor={'top'}
      >
        <div className={style.line}></div>
        <MobileMenu toggleMobileMenu={toggleMobileMenu}></MobileMenu>
      </Drawer>
    </>
  );
}
